module.exports = __webpack_public_path__ + "img/mudancas1-700x840.b2e1628e.jpg";